import React from 'react';
import { useStore } from '@xyflow/react';
import { Typography, Flex } from 'antd';
import styles from '../../timeline-node-manager.module.css';

type EventParamsProps = {
  nodeId: string;
};

const { Title, Text } = Typography;

export default function EventLinkNodeParams({ nodeId }: EventParamsProps) {
  const node = useStore((state) => state.nodes.find((n) => n.id === nodeId));
  const source = useStore((state) =>
    state.nodes.find((n) => n.id === node?.data?.sourceEvent)
  );
  const target = useStore((state) =>
    state.nodes.find((n) => n.id === node?.data?.targetEvent)
  );
  if (!node) return null;

  return (
    <Flex vertical gap={18}>
      <div>
        <Title level={5} className={styles.label}>
          Source Event: {(source?.data.name as string) || ''}
        </Title>
        <Text type='secondary' className={styles.label}>
          ID: {(node.data?.sourceEvent as string) || ''}
        </Text>
      </div>
      <div>
        <Title level={5} className={styles.label}>
          Target Event: {(target?.data.name as string) || ''}
        </Title>
        <Text type='secondary' className={styles.label}>
          ID: {(node.data?.targetEvent as string) || ''}
        </Text>
      </div>
    </Flex>
  );
}
